import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
    filterWidgetWrapper: InjectableCss;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        gap: 15,
        css: css`
            margin-bottom: 30px;
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 4, 3, 3],
        css: css`
            padding: 0 20px 0 0;
            flex-wrap: wrap;
            align-items: flex-start;
            flex-direction: column;
            @media (max-width: 768px) {
                padding: 0 10px;
            }
        `,
    },
    leftColumnTableViewGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    rightColumnGridItem: {
        width: [12, 12, 8, 9, 9],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    rightColumnTableViewGridItem: {
        width: 12,
    },
    filterWidgetWrapper: {
        css: css`
            width: 100%;
            border: 1px solid #d6d6d6;
            height: auto;
            padding: 0;
            flex-wrap: wrap;
            align-items: flex-start;
            flex-direction: column;
            @media (max-width: 768px) {
                margin-bottom: 20px;
            }
        `,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({ id, view }) => {
    const leftColumnGridItemStyle = view === "Table" ? styles.leftColumnTableViewGridItem : styles.leftColumnGridItem;
    const rightColumnGridItemStyle =
        view === "Table" ? styles.rightColumnTableViewGridItem : styles.rightColumnGridItem;
    return (
        <GridContainer {...styles.container}>
            <GridItem width={[12, 12, 3, 3, 3]} style={{ paddingTop: "0", paddingBottom: "0" }}></GridItem>
            <GridItem {...rightColumnGridItemStyle}>
                <Zone contentId={id} zoneName="ItemCountArea" />
            </GridItem>
            <GridItem {...leftColumnGridItemStyle}>
                <StyledWrapper {...styles.filterWidgetWrapper}>
                    <StyledWrapper style={{ width: "100%" }}>
                        <Zone contentId={id} zoneName="FilterContentArea" />
                    </StyledWrapper>
                    <StyledWrapper style={{ padding: "15px", width: "100%" }}>
                        <Zone contentId={id} zoneName="Content00" />
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
            <GridItem {...rightColumnGridItemStyle} style={{ paddingLeft: "0" }}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListColumns),
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
